var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMoldTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "64 64 896 896",
    focusable: "false",
    "data-icon": "press",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-mold_time"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mold_time",
    "data-name": "mold time",
    clipPath: "url(#clip-mold_time)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M630.575,473.042l-97.681-97.681V235.8a28,28,0,0,0-28-28h0a28,28,0,0,0-28,28v149.74c0,.23.012.458.018.687a27.909,27.909,0,0,0,8.183,20.53L590.977,512.64a28,28,0,0,0,39.6-39.6Z",
    fill: "#5797d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M864.628,417.3c0-194.957-158.044-353-353-353s-353,158.043-353,353q0,12.567.873,24.917a40.1,40.1,0,0,0-.873,8.323V919.932a40,40,0,0,0,40,40h626a40,40,0,0,0,40-40V450.541a40.174,40.174,0,0,0-.873-8.323Q864.616,429.87,864.628,417.3ZM301.617,207.29A297,297,0,1,1,214.628,417.3,295.055,295.055,0,0,1,301.617,207.29Zm508.25,629.234a28,28,0,0,1-28,28H241.389a28,28,0,0,1-28-28h0a28,28,0,0,1,28-28H781.867a28,28,0,0,1,28,28Z",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoldTime);
export default __webpack_public_path__ + "static/media/icon-moldTime.52be5a6074c7722014928c607ddda002.svg";
export { ForwardRef as ReactComponent };